import {Helpers} from "../../../common/js/Helpers";
import {slideToggle, slideUp} from "../../../common/js/slide";

function setQuantityNeedsCalculationMode(e) {
    Helpers.forEach(Helpers.getParent(e.target, '.lineitem-container').querySelectorAll('.eventgallery-hide-on-quantity-change'), (elm) => {
        slideUp(elm);
    })
    document.querySelector(".cart-summary").style.display = 'none';
    document.querySelector(".needs-calculation").style.display = 'block';
}

function removeItem(e) {
    e.preventDefault();
    let field = Helpers.getParent(e.target, '.lineitem-container').querySelector('input.eventgallery-quantity');
    field.value = 0;
    field.form.submit();
}

/**
 * sets the quantity to 0 and submits the form.
 */
function removeAllItems(e) {

    e.preventDefault();
    let response = confirm(window.EventGalleryCartConfiguration?.removeAllItemsWarning);
    if (response === false) {
        return;
    }
    Helpers.forEach(document.querySelectorAll('input.eventgallery-quantity'), (elm) => {
        elm.value = 0;
    })

    let form = Helpers.getParent(e.target, 'form');
    form.submit();
}

document.addEventListener('DOMContentLoaded', () => {
    Helpers.forEach(document.querySelectorAll('.scalepriceinformation'), (elm) => {
        elm.addEventListener('click', function(e) {
            e.preventDefault();
            let elm = Helpers.getParent(e.target, 'div').querySelector('div.scaleprices');
            slideToggle(elm);
        });
    })

    Helpers.forEach(document.querySelectorAll(".lineitem-container input"), (elm) => elm.addEventListener('change', setQuantityNeedsCalculationMode));
    Helpers.forEach(document.querySelectorAll(".lineitem-container select"), (elm) => elm.addEventListener('change', (e) => {
        e.target.form.submit()
    }));
    Helpers.forEach(document.querySelectorAll(".lineitem-container .delete-lineitem"), (elm) => elm.addEventListener('click', removeItem));
    Helpers.forEach(document.querySelectorAll(".eventgallery-removeAll"), (elm) => elm.addEventListener('click', removeAllItems));

    Helpers.forEach(document.querySelectorAll(".lineitem-container .add-comment"), (elm) => elm.addEventListener('click', (e) => {
        e.preventDefault();
        let textareaContainer = Helpers.getParent(e.target, '.information').querySelector('.lineitem-comment');
        if (textareaContainer) {
            textareaContainer.classList.toggle("lineitem-comment-hidden")
        }
    }));

});


